// カートに追加した商品を一度取得してから、プロパティーを変更、中身を削除して、全部を追加する方針
// カートに追加してある商品の商品IDを取得
var cartContentsId = [];
let cartAttributesObj = {};

function getCartContents() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      data.items.map((item) => {
        cartContentsId.push({
          id: item.variant_id,
          properties: item.properties,
          quantity: item.quantity,
        });
      });
      cartAttributesObj = data.attributes;
    })
    .then(() => {
      cartContentsId.reverse();
    });
}

// モーダルを表示する
function openLoadingModal() {
  document.getElementById("loadingModal").style.display = "flex";
}

getCartContents();

// 全ての日付選択フィールドをクリアする関数
function clearAllDateFields() {
  const designatedDate = document.getElementById("designatedDate");
  const designatedDateOkinawa = document.getElementById(
    "designatedDateOkinawa"
  );
  const designatedDateMainland = document.getElementById(
    "designatedDateMainland"
  );

  if (designatedDate) {
    designatedDate.innerHTML = "";
  }
  if (designatedDateOkinawa) {
    designatedDateOkinawa.innerHTML = "";
  }
  if (designatedDateMainland) {
    designatedDateMainland.innerHTML = "";
  }
}

// 期間内の日付は選択不可にする
const disabledDateRanges = [
  { start: new Date(2026, 0, 1), end: new Date(2026, 0, 1) },
];
const disabledDateAlertText =
  "1/1～1/1の着日をご指定いただけません。別の日付をお選びください。";

function isDisabledDate(targetStr) {
  if (!targetStr) {
    return false;
  }

  const [year, month, day] = targetStr.split("-").map(Number);
  const targetDate = new Date(year, month - 1, day);

  return disabledDateRanges.some((range) => {
    return targetDate >= range.start && targetDate <= range.end;
  });
}

//通常配送ラジオボタン
function normalShipping() {
  // console.log(cartContentsId);
  // モーダルを表示する
  openLoadingModal();

  // 全ての日付選択フィールドを非表示
  clearAllDateFields();

  // document.getElementById("designatedDate").innerHTML = ``;

  fetch("/cart/clear", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(() => {
    cartContentsId.map((product) => {
      product.properties = { 配送方法: "通常配送" };
    });

    var formData = {
      items: cartContentsId,
    };

    console.log(cartContentsId);
    console.log(formData);

    fetch("/cart/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        // カートの note に値を入力
        location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

//お急ぎ配送ラジオボタン
function expeditedShipping() {
  console.log(cartContentsId);

  // 全ての日付選択フィールドを非表示
  clearAllDateFields();

  document.getElementById("designatedDate").innerHTML = ``;

  fetch("/cart/clear", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(() => {
    cartContentsId.map((product) => {
      product.properties = { 配送方法: "お急ぎ配送（発送2営業日以内）" };
    });

    var formData = {
      items: cartContentsId,
    };

    fetch("/cart/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        // カートの note に値を入力
        fetch("/cart/update", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: { "cart note": JSON.stringify(cartAttributesObj) },
          }),
        })
          .then(() => {
            location.reload();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

//指定日配送ラジオボタン
document.addEventListener("DOMContentLoaded", function () {
  const specifyRadio = document.getElementById("specify");
  const specifyOkinawaRadio = document.getElementById("specify-okinawa");
  const specifyMainlandRadio = document.getElementById("specify-mainland");

  if (specifyRadio && specifyRadio.checked) {
    specifiedShipping();
  }
  if (specifyOkinawaRadio && specifyOkinawaRadio.checked) {
    specifiedShippingOkinawa();
  }
  if (specifyMainlandRadio && specifyMainlandRadio.checked) {
    specifiedShippingMainland();
  }
});

//指定日配送ラジオボタン
function specifiedShipping() {
  // 他の日付フィールドを非表示
  clearAllDateFields();

  // 営業日をカウントするカウンター
  let businessDaysCount = 0;

  // 配送予定営業日数：5日後
  const estimatedArrivalBusinessDays = 2;

  // 到着予定日：購入日
  let estimatedArrivalDate = new Date(
    new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" })
  );

  // 営業日を数える
  while (businessDaysCount < estimatedArrivalBusinessDays) {
    estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 1);

    // 休日、土曜日、または日曜日の場合、カウントしない
    if (
      !holidays_sap.includes(formatDate(estimatedArrivalDate)) &&
      estimatedArrivalDate.getDay() !== 0 &&
      estimatedArrivalDate.getDay() !== 6
    ) {
      businessDaysCount++;
    }
  }

  // 共通で3日を追加
  estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 3);

  var minDate = estimatedArrivalDate;

  var minYearNum = minDate.getFullYear(); // not getYear()
  // not getYear()年を取得
  var minMonthNum = ("00" + (minDate.getMonth() + 1)).slice(-2);
  // 月を取得。数字がゼロスタートなのでプラス1をする
  var minDayNum = ("00" + minDate.getDate()).slice(-2); // not getDay()
  // 日にちを取得。01のように二桁が必要なのでsliceを用いる
  var minDateStr =
    String(minYearNum) + "-" + String(minMonthNum) + "-" + String(minDayNum);
  // ○○○○-○○-○○で日付を表示する

  var maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);
  // maxDateを30日後に更新する

  var maxYearNum = maxDate.getFullYear();
  var maxMonthNum = ("00" + (maxDate.getMonth() + 1)).slice(-2);
  var maxDayNum = ("00" + maxDate.getDate()).slice(-2); // not getDay()
  var maxDateStr =
    String(maxYearNum) + "-" + String(maxMonthNum) + "-" + String(maxDayNum);

  // Dateピッカーを表示させる
  const specifyRadio = document.getElementById("specifiedDate");
  document.getElementById("designatedDate").innerHTML = `
    <input id="setDate" required style="border:1px solid #b0b4b2; padding:5px 10px;" type="date" name="properties[希望配送日]"  min=${minDateStr} max=${maxDateStr}
    value="${specifyRadio?.value || ""}" onkeydown="return false;"
    >
    `;

  // Dateピッカーの値が変更されたら走る関数
  const setDateInput = document.getElementById("setDate");
  setDateInput.onchange = function () {
    preferredDate = setDateInput.value;
    console.log(preferredDate);

    if (isDisabledDate(preferredDate)) {
      alert(disabledDateAlertText);
      window.location.reload();
      return;
    }

    // モーダルを表示する
    openLoadingModal();

    fetch("/cart/clear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => {
      cartContentsId.map((product) => {
        product.properties = {
          配送方法: "指定日配送",
          希望指定日: preferredDate,
        };
      });

      var formData = {
        items: cartContentsId,
      };

      fetch("/cart/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };
}

//指定日配送②(離島を除く沖縄専用)ラジオボタン
function specifiedShippingOkinawa() {
  // 他の日付フィールドを非表示
  clearAllDateFields();

  // 営業日をカウントするカウンター
  let businessDaysCount = 0;

  // 配送予定営業日数：3日後（従来通り）
  const estimatedArrivalBusinessDays = 2;

  // 到着予定日：購入日
  let estimatedArrivalDate = new Date(
    new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" })
  );

  // 営業日を数える
  while (businessDaysCount < estimatedArrivalBusinessDays) {
    estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 1);

    // 休日、土曜日、または日曜日の場合、カウントしない
    if (
      !holidays_sap.includes(formatDate(estimatedArrivalDate)) &&
      estimatedArrivalDate.getDay() !== 0 &&
      estimatedArrivalDate.getDay() !== 6
    ) {
      businessDaysCount++;
    }
  }

  // 共通で3日を追加（従来通り）
  estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 3);

  var minDate = estimatedArrivalDate;

  var minYearNum = minDate.getFullYear();
  var minMonthNum = ("00" + (minDate.getMonth() + 1)).slice(-2);
  var minDayNum = ("00" + minDate.getDate()).slice(-2);
  var minDateStr =
    String(minYearNum) + "-" + String(minMonthNum) + "-" + String(minDayNum);

  var maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);


  var maxYearNum = maxDate.getFullYear();
  var maxMonthNum = ("00" + (maxDate.getMonth() + 1)).slice(-2);
  var maxDayNum = ("00" + maxDate.getDate()).slice(-2);
  var maxDateStr =
    String(maxYearNum) + "-" + String(maxMonthNum) + "-" + String(maxDayNum);

  // Dateピッカーを表示させる
  const specifyRadio = document.getElementById("specifiedDate");
  document.getElementById("designatedDateOkinawa").innerHTML = `
    <input id="setDateOkinawa" required style="border:1px solid #b0b4b2; padding:5px 10px;" type="date" name="properties[希望配送日]"  min=${minDateStr} max=${maxDateStr}
    value="${specifyRadio?.value || ""}" onkeydown="return false;"
    >
    `;

  // Dateピッカーの値が変更されたら走る関数
  const setDateOkinawaInput = document.getElementById("setDateOkinawa");
  setDateOkinawaInput.onchange = function () {
    preferredDate = setDateOkinawaInput.value;
    console.log(preferredDate);

    if (isDisabledDate(preferredDate)) {
      alert(disabledDateAlertText);
      window.location.reload();
      return;
    }

    // モーダルを表示する
    openLoadingModal();

    fetch("/cart/clear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => {
      cartContentsId.map((product) => {
        product.properties = {
          配送方法: "指定日配送②(離島を除く沖縄専用)",
          希望指定日: preferredDate,
        };
      });

      var formData = {
        items: cartContentsId,
      };

      fetch("/cart/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };
}

//指定日配送①(沖縄、離島以外用)ラジオボタン
function specifiedShippingMainland() {
  // 他の日付フィールドを非表示
  clearAllDateFields();

  // 営業日をカウントするカウンター
  let businessDaysCount = 0;

  // 配送予定営業日数：2日後（1日前倒し）
  const estimatedArrivalBusinessDays = 2;

  // 到着予定日：購入日
  let estimatedArrivalDate = new Date(
    new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" })
  );

  // 営業日を数える
  while (businessDaysCount < estimatedArrivalBusinessDays) {
    estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 1);

    // 休日、土曜日、または日曜日の場合、カウントしない
    if (
      !holidays_sap.includes(formatDate(estimatedArrivalDate)) &&
      estimatedArrivalDate.getDay() !== 0 &&
      estimatedArrivalDate.getDay() !== 6
    ) {
      businessDaysCount++;
    }
  }

  // 2日を追加（1日短縮）
  estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 2);

  var minDate = estimatedArrivalDate;

  var minYearNum = minDate.getFullYear();
  var minMonthNum = ("00" + (minDate.getMonth() + 1)).slice(-2);
  var minDayNum = ("00" + minDate.getDate()).slice(-2);
  var minDateStr =
    String(minYearNum) + "-" + String(minMonthNum) + "-" + String(minDayNum);

  var maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);

  var maxYearNum = maxDate.getFullYear();
  var maxMonthNum = ("00" + (maxDate.getMonth() + 1)).slice(-2);
  var maxDayNum = ("00" + maxDate.getDate()).slice(-2);
  var maxDateStr =
    String(maxYearNum) + "-" + String(maxMonthNum) + "-" + String(maxDayNum);

  // Dateピッカーを表示させる
  const specifyRadio = document.getElementById("specifiedDate");
  document.getElementById("designatedDateMainland").innerHTML = `
    <input id="setDateMainland" required style="border:1px solid #b0b4b2; padding:5px 10px;" type="date" name="properties[希望配送日]"  min=${minDateStr} max=${maxDateStr}
    value="${specifyRadio?.value || ""}" onkeydown="return false;"
    >
    `;

  // Dateピッカーの値が変更されたら走る関数
  const setDateMainlandInput = document.getElementById("setDateMainland");
  setDateMainlandInput.onchange = function () {
    preferredDate = setDateMainlandInput.value;
    console.log(preferredDate);

    if (isDisabledDate(preferredDate)) {
      alert(disabledDateAlertText);
      window.location.reload();
      return;
    }

    // モーダルを表示する
    openLoadingModal();

    fetch("/cart/clear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => {
      cartContentsId.map((product) => {
        product.properties = {
          配送方法: "指定日配送①(沖縄、離島以外用)",
          希望指定日: preferredDate,
        };
      });

      var formData = {
        items: cartContentsId,
      };

      fetch("/cart/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };
}
